
 import { mapState } from 'vuex'
 import dayjs from 'dayjs' // 时间转换
 import mtMapOverly from '@/components/company/v2/mtMapOverly.vue'
 import googleMap from '@/components/company/v2/mtGoogleMap.vue'
 import companyBasic from '@/components/company/v2/companyBasic.vue'
 const _ = require('lodash')
 const xPI = (Number('3.14159265352348979324') * 3000.0) / 180.0
 const PI = Number('3.1415926535897932384626')
 const a = 6378245.0
 const ee = Number('0.00669342162296594323')
export default {
  components: {
    googleMap,
    mtMapOverly,
    companyBasic
  },
  // inject: ['main'],
  props: {
      mtData: {
        type: Object,
        default: () => {}
      },
      titleName: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        lan: this.$store.state.LanguageCode,
        zoom: 1, // 缩放级别
        dragging: true, // 地图拖拽
        markerPoint: { lng: '139.1104353', lat: "35.5085647" }, // 地图位置
        mapDetail: {"baiduAddr":"120.5,31.5","googleAddr":"31.49372356511991,120.49356586489472","baiduZoom":6,"googleZoom":6},
        isH5Show: false,
        serverPop: false,
        serverIpPop: false,
        isLeverPop: false,
        isShowMap: false,
        serverDistribution: '',
        identificationResult: '',
        updateDate: '',
        ipUpdateDate: '',
        serverIndex: 1,
        servertabs: [],
        serverDataList: [],
        allServersData: [],
        mt4ServersData: [],
        mt5ServersData: [],
        leverDataList: [],
        serverIPObj: '',
        previewLocationList: [],
        echartsLocationList: [],
        topServerList: [],
        type: '',
        MT45TypeText: this.GetMT45TypeText(),
        mapecharts: null, // echarts地图
        companyBasic: {}
      }
    },
    computed: {
      ...mapState({
        realCountry: 'myCountry'
      }),
      isZh() {
        const code = this.$store.state.LanguageCode
        if (code == 'zh-cn' || code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
          return true
        } else {
          return false
        }
      }
    },
    mounted() {
      this.initeData()
      // console.log(this.previewLocationList, 'this.previewLocationList');
    },
    methods: {
      async initeData(mttype, softwareId) {
        this.type = mttype || ''
        this.MT45TypeText = this.GetMT45TypeText()
        let mtData2 = {}
        if (this.type == '1' || this.type == '2') {
          mtData2 = await this.getDetail(softwareId)
          // console.log('mtData2', mtData2)
        } else {
          mtData2 = _.cloneDeep(this.mtData)
        }

        if (mtData2?.serverDistribution?.serverDistributionList.length > 3) {
          const tempList = _.cloneDeep(mtData2?.serverDistribution?.serverDistributionList)
          let tempToatal = 0
          tempList.forEach((item) => {
            tempToatal = tempToatal + item.totalCount
          })
          // console.log(tempToatal, 'tempToatal');
          const otherNum = tempToatal - (tempList[0].totalCount + tempList[1].totalCount)
          // console.log(otherNum, 'otherNum');
          this.topServerList = []
          this.topServerList.push(tempList[0], tempList[1])
          this.topServerList.push({
            totalCount: otherNum,
            flag: '',
            countryName: this.$t('20793'),
            twoCharCountryCode: this.$t('20793')
          })
        } else {
          this.topServerList = mtData2?.serverDistribution?.serverDistributionList
        }

        this.serverDistribution = mtData2?.serverDistribution || '' // 服务器分布
        this.identificationResult = mtData2?.identificationResult || '' // 鉴定结果
        this.updateDate = this.serverDistribution?.updateDate ? dayjs(new Date(Number(this.serverDistribution.updateDate))).format('YYYY-MM-DD') : ''
        // console.log(mtData2, 'mtDatamtData')
        this.allServersData = mtData2?.serverList?.allServers || []
        this.servertabs = []
        if (this.allServersData.length) {
          this.servertabs.push({
            name: this.$t('49234'),
            type: 1
          })
        }
        this.mt4ServersData = mtData2?.serverList?.mT4_Servers || []
        if (this.mt4ServersData.length) {
          this.servertabs.push({
            name: 'MT4',
            type: 2
          })
        }
        this.mt5ServersData = mtData2?.serverList?.mT5_Servers || []
        if (this.mt5ServersData.length) {
          this.servertabs.push({
            name: 'MT5',
            type: 3
          })
        }
        this.serverDataList = this.allServersData
        this.echartsLocationList = _.cloneDeep(mtData2?.globalLocation?.previewLocations || [])
        this.previewLocationList = _.cloneDeep(mtData2?.globalLocation?.previewLocations || [])
        this.previewLocationList && this.previewLocationList.length > 0 && this.previewLocationList.map((item) => {
          item.google = this.wgs84togcj02(item.latitude, item.longitude)
          item.baidu = this.gcj02tobd09(item.google[0], item.google[1])
          // console.log(item);
          item.longitude = item.baidu[0] + ''
          item.latitude = item.baidu[1] + ''
          return item
      })
      // console.log('this.identificationResult', this.identificationResult)
    },
    async getDetail(softwareId) {
      const ret = await this.$api.common
      .CV3({
        traderCode: '',
        softwareId
      }, {
        Routes: 'wikifxagg$mt4_mt5_appraise_v2'
      })
      return ret?.wikifxagg?.mt4_mt5_appraise_v2?.data || {}
    },
    GetMT45TypeText() {
      let text = this.$t('21440')
      if (this.isZh) {
        text = text.replace('MT4/5', 'MT4/5 ')
      }
      if (this.type == "1" || this.type == "2") {
        text = text.replace('MT4/5', (this.type == "1" ? 'MT4' : 'MT5'))
      }
      return text
    },
    async showMt(item) {
      const mttype = item?.softwareType ? item?.softwareType + '' : ''
      const softwareId = item?.softwareId || ''
      await this.initeData(mttype, softwareId)
      this.isH5Show = true
      if(this.isScriptLoaded('https://resources1.interface003.com/web20/word.js')){
        setTimeout(()=>{
          // console.log('this.echartsLocationList--1', this.echartsLocationList)
          this.getData(this.echartsLocationList)
        },100)
      } else {
        // console.log('否');
        window.echarts = this.$echarts
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = 'https://resources1.interface003.com/web20/word.js'
        document.body.insertBefore(script, document.body.firstChild)
        // console.log(window.echarts = this.$echarts, 1234)
        script.onload = () => {
          setTimeout(() => {
            // console.log('this.echartsLocationList--2', this.echartsLocationList)
              this.getData(this.echartsLocationList)
            },100)
        }
      }
      document.body.style.overflow = 'hidden'
      // console.log('document.body.: ', document.body)
    },
    isScriptLoaded(src) {
      const scripts = document.getElementsByTagName('script')
      for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].getAttribute('src') == src) {
          return true
        }
      }
      return false
    },
    mapClick() {
      this.isShowMap = true
    },
    tabswitch(i) {
      if (i == 1)(this.serverDataList = this.allServersData)
      else if (i == 2)(this.serverDataList = this.mt4ServersData)
      else if (i == 3)(this.serverDataList = this.mt5ServersData)
      this.serverIndex = i
    },
        close () {
            this.isH5Show = false
             document.body.style.overflow = 'auto'
        },
        openIpDialog(item) {
          this.companyBasic = item?.companyBasic
          // console.log(item, 8886 + 'tyu')
          if (item.serverIPList.list.length) {
            this.serverIPObj = item.serverIPList
            this.ipUpdateDate = dayjs(new Date(Number(this.serverIPObj.updateDate))).format('YYYY-MM-DD')
              this.serverIpPop = true
          }
        },
        leverPopClick (item) {
          if (!item || !item.leverage) {
            return
          }
          this.leverDataList = item.leverageDetailList
          this.isLeverPop = true
        },
        pingIcon(i) {
            if (i == 1) return 'https://resources1.interface003.com/web20/img/commen/green.gif'
            else if (i == 2) return 'https://resources1.interface003.com/web20/img/commen/yellow.gif'
            else if (i == 3) return 'https://resources1.interface003.com/web20/img/commen/red.gif'
            else return 'https://resources1.interface003.com/web20/img/commen/red.gif'
        },
        getData (country = []) {
          const worldData = this.GetWorldData()
          const datalist = []
          worldData.forEach((item) => {
            const selData = worldData.find((p) => {
              return p.countrycode == item.TwoCode
            })
            if (selData) {
              datalist.push({
                value: selData.score,
                name: item.Name
              })
            } else {
              datalist.push({
                value: -1,
                name: item.Name
              })
            }
          })
          const info = []
          // #00DD96'
          //  '#FADC19'
          //  '#F15555'
          if (country.length > 0) {
            country.forEach((item) => {
              info.push({
                value: [item.latitude, item.longitude],
                symbolSize :10,
                // rippleEffect: {
                //   scale: 0.8
                // },
                symbol: item.velocity == 1 ?'image://https://resources1.interface003.com/appuni/images/green.gif': item.velocity == 2 ? 'image://https://resources1.interface003.com/appuni/images/yellow.gif':
                'image://https://resources1.interface003.com/appuni/images/red.gif',
              })
            })
          }
          if (this.isH5Show) {
            // console.log('info', info)
            this.loadEcharts(datalist,info)
          }
       },
       GetWorldData() {
        const worldData = [
            { TwoCode: 'AF', Name: 'Afghanistan' },
            { TwoCode: 'AL', Name: 'Albania' },
            { TwoCode: 'AQ', Name: 'Antarctica' },
            { TwoCode: 'DZ', Name: 'Algeria' },
            { TwoCode: 'AS', Name: 'American Samoa' },
            { TwoCode: 'AD', Name: 'Andorra' },
            { TwoCode: 'AO', Name: 'Angola' },
            { TwoCode: 'AZ', Name: 'Azerbaijan' },
            { TwoCode: 'AR', Name: 'Argentina' },
            { TwoCode: 'AU', Name: 'Australia' },
            { TwoCode: 'AT', Name: 'Austria' },
            { TwoCode: 'BS', Name: 'Bahamas' },
            { TwoCode: 'BH', Name: 'Bahrain' },
            { TwoCode: 'AM', Name: 'Armenia' },
            { TwoCode: 'BB', Name: 'Barbados' },
            { TwoCode: 'BE', Name: 'Belgium' },
            { TwoCode: 'BM', Name: 'Bermuda' },
            { TwoCode: 'BT', Name: 'Bhutan' },
            { TwoCode: 'BO', Name: 'Bolivia' },
            { TwoCode: 'BW', Name: 'Botswana' },
            { TwoCode: 'BR', Name: 'Brazil' },
            { TwoCode: 'BZ', Name: 'Belize' },
            { TwoCode: 'VG', Name: 'The Virgin Islands' },
            { TwoCode: 'BN', Name: 'Brunei' },
            { TwoCode: 'BG', Name: 'Bulgaria' },
            { TwoCode: 'MM', Name: 'Myanmar' },
            { TwoCode: 'BI', Name: 'Burundi' },
            { TwoCode: 'BY', Name: 'Belarus' },
            { TwoCode: 'KH', Name: 'Cambodia' },
            { TwoCode: 'CM', Name: 'Cameroon' },
            { TwoCode: 'CA', Name: 'Canada' },
            { TwoCode: 'CV', Name: 'Cape Verde' },
            { TwoCode: 'LK', Name: 'Sri Lanka' },
            { TwoCode: 'TD', Name: 'Chad' },
            { TwoCode: 'CL', Name: 'Chile' },
            { TwoCode: 'CN', Name: 'China' },
            { TwoCode: 'TW', Name: 'China Taiwan' },
            { TwoCode: 'CX', Name: 'Christmas Island' },
            { TwoCode: 'CC', Name: 'Cocos Islands' },
            { TwoCode: 'CO', Name: 'Colombia' },
            { TwoCode: 'KM', Name: 'Comoros' },
            { TwoCode: 'YT', Name: 'Mayotte' },
            { TwoCode: 'CK', Name: 'Island' },
            { TwoCode: 'CR', Name: 'Costa Rica' },
            { TwoCode: 'HR', Name: 'Croatia' },
            { TwoCode: 'CU', Name: 'Cuba' },
            { TwoCode: 'BJ', Name: 'Benin' },
            { TwoCode: 'DK', Name: 'Denmark' },
            { TwoCode: 'DM', Name: 'Dominic' },
            { TwoCode: 'EC', Name: 'Ecuador' },
            { TwoCode: 'ET', Name: 'Ethiopia' },
            { TwoCode: 'ER', Name: 'Eritrea' },
            { TwoCode: 'EE', Name: 'Estonia' },
            { TwoCode: 'FI', Name: 'Finland' },
            { TwoCode: 'FR', Name: 'France' },
            { TwoCode: 'DJ', Name: 'Djibouti' },
            { TwoCode: 'GA', Name: 'Gabon' },
            { TwoCode: 'GE', Name: 'Georgia' },
            { TwoCode: 'GM', Name: 'Gambia' },
            { TwoCode: 'PS', Name: 'Palestine' },
            { TwoCode: 'DE', Name: 'Germany' },
            { TwoCode: 'GH', Name: 'Ghana' },
            { TwoCode: 'GI', Name: 'Gibraltar' },
            { TwoCode: 'KI', Name: 'Kiribati' },
            { TwoCode: 'GR', Name: 'Greece' },
            { TwoCode: 'GL', Name: 'Greenland' },
            { TwoCode: 'GD', Name: 'Grenada' },
            { TwoCode: 'GP', Name: 'Guadeloupe' },
            { TwoCode: 'GU', Name: 'Guam' },
            { TwoCode: 'GT', Name: 'Guatemala' },
            { TwoCode: 'GN', Name: 'Guinea' },
            { TwoCode: 'GY', Name: 'Guyana' },
            { TwoCode: 'HT', Name: 'Haiti' },
            { TwoCode: 'VA', Name: 'Vatican' },
            { TwoCode: 'HN', Name: 'Honduras' },
            { TwoCode: 'HK', Name: 'China Hong Kong' },
            { TwoCode: 'HU', Name: 'Hungary' },
            { TwoCode: 'IS', Name: 'Iceland' },
            { TwoCode: 'IN', Name: 'India' },
            { TwoCode: 'ID', Name: 'Indonesia' },
            { TwoCode: 'IR', Name: 'Iran' },
            { TwoCode: 'IQ', Name: 'Iraq' },
            { TwoCode: 'IE', Name: 'Ireland' },
            { TwoCode: 'IL', Name: 'Israel' },
            { TwoCode: 'IT', Name: 'Italy' },
            { TwoCode: 'JM', Name: 'Jamaica' },
            { TwoCode: 'JP', Name: 'Japan' },
            { TwoCode: 'KZ', Name: 'Kazakhstan' },
            { TwoCode: 'JO', Name: 'Jordan' },
            { TwoCode: 'KE', Name: 'Kenya' },
            { TwoCode: 'KR', Name: 'Korea' },
            { TwoCode: 'KW', Name: 'Kuwait' },
            { TwoCode: 'KG', Name: 'Kyrgyzstan' },
            { TwoCode: 'LB', Name: 'Lebanon' },
            { TwoCode: 'LS', Name: 'Lesotho' },
            { TwoCode: 'LV', Name: 'Latvia' },
            { TwoCode: 'LR', Name: 'Liberia' },
            { TwoCode: 'LY', Name: 'Libya' },
            { TwoCode: 'LI', Name: 'Liechtenstein' },
            { TwoCode: 'LT', Name: 'Lithuania' },
            { TwoCode: 'LU', Name: 'Luxembourg' },
            { TwoCode: 'MO', Name: 'Macao' },
            { TwoCode: 'MG', Name: 'Madagascar' },
            { TwoCode: 'MW', Name: 'Malawi' },
            { TwoCode: 'MY', Name: 'Malaysia' },
            { TwoCode: 'MV', Name: 'Maldives' },
            { TwoCode: 'ML', Name: 'Mali' },
            { TwoCode: 'MT', Name: 'Malta' },
            { TwoCode: 'MQ', Name: 'Martinique' },
            { TwoCode: 'MR', Name: 'Mauritania' },
            { TwoCode: 'MU', Name: 'Mauritius' },
            { TwoCode: 'MX', Name: 'Mexico' },
            { TwoCode: 'MC', Name: 'Monaco' },
            { TwoCode: 'MN', Name: 'Mongolia' },
            { TwoCode: 'MD', Name: 'Moldova' },
            { TwoCode: 'ME', Name: 'Montenegro' },
            { TwoCode: 'MA', Name: 'Morocco' },
            { TwoCode: 'MZ', Name: 'Mozambique' },
            { TwoCode: 'OM', Name: 'Oman' },
            { TwoCode: 'NA', Name: 'Namibia' },
            { TwoCode: 'NR', Name: 'Nauru' },
            { TwoCode: 'NP', Name: 'Nepal' },
            { TwoCode: 'NL', Name: 'Netherlands' },
            { TwoCode: 'AW', Name: 'Aruba' },
            { TwoCode: 'NC', Name: 'New Caledonia' },
            { TwoCode: 'VU', Name: 'Vanuatu' },
            { TwoCode: 'NZ', Name: 'New Zealand' },
            { TwoCode: 'NI', Name: 'Nicaragua' },
            { TwoCode: 'NE', Name: 'Niger' },
            { TwoCode: 'NG', Name: 'Nigeria' },
            { TwoCode: 'NU', Name: 'Niue' },
            { TwoCode: 'NF', Name: 'Norfolk Island' },
            { TwoCode: 'NO', Name: 'Norway' },
            { TwoCode: 'MH', Name: 'Marshall Islands' },
            { TwoCode: 'PW', Name: 'Palau' },
            { TwoCode: 'PK', Name: 'Pakistan' },
            { TwoCode: 'PA', Name: 'Panama' },
            { TwoCode: 'PG', Name: 'Papua New Guinea' },
            { TwoCode: 'PY', Name: 'Paraguay' },
            { TwoCode: 'PE', Name: 'Peru' },
            { TwoCode: 'PH', Name: 'Philippines' },
            { TwoCode: 'PN', Name: 'Pitcairn Islands' },
            { TwoCode: 'PL', Name: 'Poland' },
            { TwoCode: 'PT', Name: 'Portugal' },
            { TwoCode: 'GW', Name: 'Guinea-Bissau' },
            { TwoCode: 'QA', Name: 'Qatar' },
            { TwoCode: 'RE', Name: 'Reunion' },
            { TwoCode: 'RO', Name: 'Romania' },
            { TwoCode: 'RU', Name: 'Russia' },
            { TwoCode: 'RW', Name: 'Rwanda' },
            { TwoCode: 'BL', Name: 'St. Barthelemy' },
            { TwoCode: 'KN', Name: 'Saint Kitts and Nevis' },
            { TwoCode: 'AI', Name: 'Anguilla' },
            { TwoCode: 'LC', Name: 'Saint Lucia' },
            { TwoCode: 'SM', Name: 'San Marino' },
            { TwoCode: 'SA', Name: 'Saudi Arabia' },
            { TwoCode: 'SN', Name: 'Senegal' },
            { TwoCode: 'RS', Name: 'Serbia' },
            { TwoCode: 'SC', Name: 'Seychelles' },
            { TwoCode: 'SL', Name: 'Sierra Leone' },
            { TwoCode: 'SG', Name: 'Singapore' },
            { TwoCode: 'SK', Name: 'Slovakia' },
            { TwoCode: 'VN', Name: 'Vietnam' },
            { TwoCode: 'SI', Name: 'Slovenia' },
            { TwoCode: 'SO', Name: 'Somalia' },
            { TwoCode: 'ZA', Name: 'South Africa' },
            { TwoCode: 'ZW', Name: 'Zimbabwe' },
            { TwoCode: 'ES', Name: 'Spain' },
            { TwoCode: 'SD', Name: 'Sudan' },
            { TwoCode: 'SR', Name: 'Suriname' },
            { TwoCode: 'SZ', Name: 'Swaziland' },
            { TwoCode: 'SE', Name: 'Sweden' },
            { TwoCode: 'CH', Name: 'Switzerland' },
            { TwoCode: 'SY', Name: 'Syria' },
            { TwoCode: 'TJ', Name: 'Tajikistan' },
            { TwoCode: 'TH', Name: 'Thailand' },
            { TwoCode: 'TG', Name: 'Togo' },
            { TwoCode: 'TK', Name: 'Tokelau' },
            { TwoCode: 'TO', Name: 'Tonga' },
            { TwoCode: 'TT', Name: 'Trinidad and Tobago' },
            { TwoCode: 'AE', Name: 'United Arab Emirates' },
            { TwoCode: 'TN', Name: 'Tunisia' },
            { TwoCode: 'TR', Name: 'Turkey' },
            { TwoCode: 'TM', Name: 'Turkmenistan' },
            { TwoCode: 'TV', Name: 'Tuvalu' },
            { TwoCode: 'UG', Name: 'Uganda' },
            { TwoCode: 'UA', Name: 'Ukraine' },
            { TwoCode: 'MK', Name: 'Macedonia' },
            { TwoCode: 'EG', Name: 'Egypt' },
            { TwoCode: 'UK', Name: 'United Kingdom' },
            { TwoCode: 'JE', Name: 'Jersey' },
            { TwoCode: 'IM', Name: 'Isle of Man' },
            { TwoCode: 'TZ', Name: 'Tanzania' },
            { TwoCode: 'US', Name: 'United States' },
            { TwoCode: 'BF', Name: 'Burkina Faso' },
            { TwoCode: 'UY', Name: 'Uruguay' },
            { TwoCode: 'UZ', Name: 'Uzbekistan' },
            { TwoCode: 'VE', Name: 'Venezuela' },
            { TwoCode: 'WF', Name: 'Wallis and Futuna' },
            { TwoCode: 'WS', Name: 'Samoa' },
            { TwoCode: 'YE', Name: 'Yemen' },
            { TwoCode: 'ZM', Name: 'Zambia' },
            { TwoCode: 'EH', Name: 'W. Sahara' },
            { TwoCode: 'AX', Name: 'Aland' },
            { TwoCode: 'GF', Name: 'Fr. S. Antarctic Lands' },
            { TwoCode: 'AG', Name: 'Antigua and Barb.' },
            { TwoCode: 'BD', Name: 'Bangladesh' },
            { TwoCode: 'BA', Name: 'Bosnia and Herz.' },
            { TwoCode: 'CF', Name: 'Central African Rep.' },
              { TwoCode: 'CI', Name: "Côte d'Ivoire" }, // eslint-disable-line
            { TwoCode: 'CD', Name: 'Dem. Rep. Congo' },
            { TwoCode: 'CG', Name: 'Congo' },
            { TwoCode: 'KY', Name: 'Cayman Is.' },
            { TwoCode: 'CY', Name: 'N. Cyprus' },
            { TwoCode: 'CZ', Name: 'Czech Rep.' },
            { TwoCode: 'DO', Name: 'Dominican Rep.' },
            { TwoCode: 'FJ', Name: 'Fiji' },
            { TwoCode: 'FK', Name: 'Falkland Is.' },
            { TwoCode: 'LA', Name: 'Lao PDR' },
            { TwoCode: 'FO', Name: 'Faeroe Is.' },
            { TwoCode: 'FM', Name: 'Micronesia' },
            { TwoCode: 'GQ', Name: 'Eq. Guinea' },
            { TwoCode: 'HM', Name: 'Heard I. and McDonald Is.' },
            { TwoCode: 'IO', Name: 'Br. Indian Ocean Ter.' },
            { TwoCode: 'MP', Name: 'N. Mariana Is.' },
            { TwoCode: 'MS', Name: 'Montserrat' },
            { TwoCode: 'KP', Name: 'Dem. Rep. Korea' },
            { TwoCode: 'PF', Name: 'Fr. Polynesia' },
            { TwoCode: 'SS', Name: 'S. Sudan' },
            { TwoCode: 'GS', Name: 'S. Geo. and S. Sandw. Is.' },
            { TwoCode: 'SH', Name: 'Saint Helena' },
            { TwoCode: 'SB', Name: 'Solomon Is.' },
            { TwoCode: 'SV', Name: 'El Salvador' },
            { TwoCode: 'PM', Name: 'St. Pierre and Miquelon' },
            { TwoCode: 'ST', Name: 'São Tomé and Principe' },
            { TwoCode: 'TC', Name: 'Turks and Caicos Is.' },
            { TwoCode: 'TL', Name: 'Timor-Leste' },
            { TwoCode: 'VC', Name: 'St. Vin. and Gren.' },
            { TwoCode: 'VI', Name: 'U.S. Virgin Is.' }
          ]
          return worldData
       },
        loadEcharts(worlddata,scatter) {
          const option = {
            backgroundColor: 'transparent',
            label: {
                show: false
            },
            grid: {
              show: false,
              tooltip: {
                show: false
              }
            },
            select: {
              itemStyle: {
                  color: '#fff',
                  areaColor: "rgb(81,133,180)",
                  emphasis: {
                    show: true,
                    label: {
                      fontSize: 0,
                    }
                },
              },
            },
            geo: {
              map: 'world',
              zoom: 1.2,
              show: true,
              roam: false,
              label: {
                fontSize:0,
                show: false,
                Emphasis: {
                  show: false
                }
              },
              itemStyle: {
                  borderColor: 'rgba(255, 255, 255, 0.40)',
                  borderWidth: 1,
                  areaColor: "rgb(81,133,180)",
                  color: "rgb(81,133,180)",
                },
            },
            series: [
              {
              label: {
                show: false,
                fontSize: 0,
              },
                name: 'world',
                type: 'map',
                map: 'world',
                animation: false, // 去掉动画效果
                roam: false,
                zoom: 1.2,
                itemStyle: {
                  borderColor: 'rgba(255, 255, 255, 0.40)',
                  borderWidth: 1,
                  areaColor: "rgb(81,133,180)",
                  color: "rgb(81,133,180)",
                },
                emphasis: {
                  show: true,
                  areaColor: '#FFFFFF',
                  label: {
                    show: true,
                    formatter: (params) => { return params.name },
                    color: '#FFFFFF',
                    strokeColor: '#FFFFFF',
                    fontSize: 0,
                    textBorderColor: '#FFFFFF',
                    textBorderWidth: 2
                  }
                },
                data: worlddata
              },
              {
                type: 'effectScatter',
                coordinateSystem: 'geo',
                symbolSize: 600,
                // rippleEffect: {
                //   scale: 1
                // },
                data: scatter
              }
            ]
          }
          // console.log(this.$refs.mapbox, '1111');
          
          const dom2 = document.getElementById("mapbox");
          // console.log('dom2: ', dom2);
          this.mapecharts && this.mapecharts.dispose()
          this.mapecharts = this.$echarts.init(dom2, null, { renderer: 'svg' });
          this.mapecharts.setOption(option, true);

          // 监听 click 事件
          this.mapecharts.on('click', (params) => {
              // console.log('params: ', params);
              if (params.componentType === 'series') {
                  // 点击的是地图系列（series）
                  const geoCoord = params.value; // 获取点击位置的经纬度数组 [经度, 纬度]
                  // console.log(geoCoord, 'geoCoord');
                  const templt = this.wgs84togcj02(geoCoord[0], geoCoord[1])
                  const tempbdlt = this.gcj02tobd09(templt[0], templt[1])
                  // console.log(this.markerPoint, 'markerPoint');
                  if (geoCoord.length > 1) {
                      this.markerPoint = { lng: tempbdlt[0], lat: tempbdlt[1] } // 地图位置
                    this.$nextTick(() => {
                       this.isShowMap = true
                    });
                  }
              }
          });
        },
         wgs84togcj02(lng, lat) { // WGS-84 转 GCJ-02
                const _lat = +lat
                const _lng = +lng

                // if (!(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55)) {
                // 	console.log('是在国内');
                // 	return [lng, lat]
                // } else {
                let dlat = this.transformlat(_lng - 105.0, _lat - 35.0)
                let dlng = this.transformlng(_lng - 105.0, _lat - 35.0)
                const radlat = (_lat / 180.0) * PI
                let magic = Math.sin(radlat)
                magic = 1 - ee * magic * magic
                const sqrtmagic = Math.sqrt(magic)
                dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI)
                dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI)
                const mglat = _lat + dlat
                const mglng = _lng + dlng
                return [mglng, mglat]
                // }
            },
            gcj02tobd09(lng, lat) {
                const _lat = +lat
                const _lng = +lng
                const z = Math.sqrt(lng * _lng + _lat * lat) + 0.00002 * Math.sin(_lat * xPI)
                const theta = Math.atan2(_lat, _lng) + 0.000003 * Math.cos(lng * xPI)
                const bdLng = z * Math.cos(theta) + 0.0065
                const bdLat = z * Math.sin(theta) + 0.006
                return [bdLng, bdLat]
            },
            transformlat(lng, lat) {
                const _lat = +lat
                const _lng = +lng
                let ret = -100.0 + 2.0 * _lng + 3.0 * _lat + 0.2 * _lat * _lat + 0.1 * _lng * _lat + 0.2 * Math.sqrt(Math.abs(_lng))
                ret += ((20.0 * Math.sin(6.0 * _lng * PI) + 20.0 * Math.sin(2.0 * _lng * PI)) * 2.0) / 3.0
                ret += ((20.0 * Math.sin(_lat * PI) + 40.0 * Math.sin((_lat / 3.0) * PI)) * 2.0) / 3.0
                ret += ((160.0 * Math.sin((_lat / 12.0) * PI) + 320 * Math.sin((_lat * PI) / 30.0)) * 2.0) / 3.0
                return ret
            },
            transformlng(lng, lat) {
                const _lat = +lat
                const _lng = +lng
                let ret = 300.0 + _lng + 2.0 * _lat + 0.1 * _lng * _lng + 0.1 * _lng * _lat + 0.1 * Math.sqrt(Math.abs(lng))
                ret += ((20.0 * Math.sin(6.0 * _lng * PI) + 20.0 * Math.sin(2.0 * _lng * PI)) * 2.0) / 3.0
                ret += ((20.0 * Math.sin(_lng * PI) + 40.0 * Math.sin((_lng / 3.0) * PI)) * 2.0) / 3.0
                ret += ((150.0 * Math.sin((_lng / 12.0) * PI) + 300.0 * Math.sin((_lng / 30.0) * PI)) * 2.0) / 3.0
                return ret
            }
    },
}
